export default "__VITE_ASSET__CELWoOzm__"